export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '';
  return new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF'
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('de-CH').format(date);
  } catch (e) {
    return dateString;
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('de-CH', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  } catch (e) {
    return dateString;
  }
};

export const getStatusLabel = (status) => {
  const statusLabels = {
    DRAFT: 'Bozza',
    IN_REVIEW: 'In Revisione',
    NEEDS_CORRECTION: 'Da Correggere',
    APPROVED: 'Approvato',
    INVOICED: 'Fatturato',
    CANCELLED: 'Annullato',
    ISSUED: 'Emessa',
    OVERDUE: 'Scaduta',
    SETTLED: 'Saldata'
  };
  return statusLabels[status] || status;
};

export const getStatusColor = (status) => {
  const colors = {
    DRAFT: 'status-draft',
    IN_REVIEW: 'status-in-review',
    NEEDS_CORRECTION: 'status-needs-correction',
    APPROVED: 'status-approved',
    INVOICED: 'status-invoiced',
    CANCELLED: 'bg-red-100 text-red-700',
    ISSUED: 'bg-blue-100 text-blue-700',
    OVERDUE: 'bg-orange-100 text-orange-700',
    SETTLED: 'bg-green-100 text-green-700'
  };
  return colors[status] || 'bg-gray-100 text-gray-700';
};

export const getRoleLabel = (role) => {
  const roleLabels = {
    ADMIN: 'Amministratore',
    MANAGER: 'Responsabile',
    SECRETARY: 'Segretaria',
    EMPLOYEE: 'Impiegato',
    SHARED: 'Condiviso'
  };
  return roleLabels[role] || role;
};
